<template>
  <div class="row">
    <div id="msform">
      <div
        v-if="index > 1"
        class="back-icon"
        @click="onBack()">
        <i class="fa fa-arrow-left"/>
      </div>
      <ul id="progressbar">
        <li :class="{'active': index >= 1}">Địa chỉ</li>
        <!--        <li :class="{'active': index >= 2}">Thanh toán</li>-->
        <li :class="{'active': index >= 2}">Xác nhận</li>
      </ul>
    </div>
    <div
      v-if="index === 1"
      class="content">
      <h5>Thông tin khách hàng</h5>
      <form @submit.prevent="onSaveAddress">
        <div class="form-group">
          <div class="col-sm-12">
            <input
              v-model="name"
              type="text"
              class="form-control"
              placeholder="Tên người nhận">
          </div>
        </div>
        <div class="form-group">
          <div class="col-12">
            <input
              v-model="phone"
              type="text"
              class="form-control"
              placeholder="Số điện thoại">
            <span style="color: red">Người giao hàng sẽ liên hệ nếu cần !</span>
          </div>
        </div>
        <div class="form-group">
          <div class="col-12">
            <input
              v-model="address"
              type="text"
              class="form-control"
              placeholder="Địa chỉ người nhận">
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-success col-12">Giao đến địa chỉ này
        </button>
      </form>
    </div>
    <div
      v-if="index === 2"
      class="content-confirm">
      <div class="confirm">
        <div class="title">Địa chỉ nhận hàng</div>
        <div class="detail">{{ phone }}</div>
        <div class="detail">{{ address }}</div>
      </div>
      <div class="confirm">
        <div class="title">Phương thức thanh toán</div>
        <div class="detail">{{ paymentMethods[paymentMethod - 1] }}</div>
      </div>
      <div class="confirm">
        <div class="title">Thông tin đơn hàng</div>
        <div class="row">
          <div
            v-for="cart in carts"
            class="col-sm-6 col-md-4 col-lg-4">
            <card-item
              :vatpham="cart"
              :mode="'view'"/>
          </div>
        </div>
      </div>
      <div class="confirm">
        <div class="amount-detail">
          <div class="title">
            Thành tiền:
          </div>
          <span class="amount">
            {{ amount }} đ
          </span>
        </div>
        <div class="detail-vat text-right">Đã bao gồm VAT</div>
        <button
          :disabled="isSubmitting"
          type="button"
          class="btn btn-success col-12"
          @click="orderItem()">Tiến hành đặt hàng
        </button>
      </div>

    </div>
  </div>

</template>

<script>
  import formatMoney from '../../utils/StringUtils'
  import CardItem from '../cart/CardItem'
  import rf from '../../communicate/RequestFactory'
  import {errorToaster, infoToaster} from '../../services/ErrorHandler'
  import PaymentMethod from '../../communicate/PaymentMethod'
  import validatorPhone from '../../utils/PhoneValidator'
  import OrderType from '../../communicate/OrderType'
  import {getUrlPayment} from '../../services/authService'

  export default {
    name: 'Payment',
    components: {
      CardItem
    },
    data () {
      return {
        paymentMethods: [
          'Thanh toán tiền mặt khi nhận hàng',
          'Thanh toán qua Momo',
          'Thanh toán qua tài khoản ngân hàng',
          'Thanh toán qua Viettel Pay',
          'Thanh toán qua Ví Việt'
        ],
        index: 1,
        name: '',
        phone: '',
        address: '',
        paymentMethod: 9,
        carts: [],
        amount: 0,
        discount: 0,
        real_amount: 0,
        loader: null,
        isSubmitting: false,
      }
    },
    mounted () {
      this.loadCarts()
      this.$store.watch(
        (state, getters) => getters.getCartUpdate,
        (newValue, oldValue) => {
          this.loadCarts()
        },
      )
      const addressStorage = localStorage.getItem('address')

      if (addressStorage) {
        const userAddress = JSON.parse(addressStorage)
        this.name = userAddress.name
        this.phone = userAddress.phone
        this.address = userAddress.address
      }
    },
    methods: {
      onSaveAddress () {
        const address = {
          name: this.name,
          phone: this.phone,
          address: this.address
        }

        if (validatorPhone(address.phone)) {
          localStorage.setItem('address', JSON.stringify(address))
          this.index = 2
        }
      },

      loadCarts () {
        const cartsListStorage = localStorage.getItem('carts')
        this.carts = cartsListStorage ? JSON.parse(cartsListStorage) : []
        this.flashSale(PaymentMethod.PAYMENT_VTC_PAY)
      },

      flashSale (payment_method) {
        let that = this
        rf.getRequest('FlashSaleRequest').flashSale(payment_method).then((res) => {
          if (res.status === 200) {
            that.calculateMoney(res.data)
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`})
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(err => {
          errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
        })
      },

      calculateMoney (data) {
        this.amount = 0
        if (this.carts && this.carts.length > 0) {
          const totalAmount = this.carts.reduce((amount, item) => {
            return amount + parseInt(item.price_sale && (item.price_sale + '').replace(new RegExp(',', 'g'), '')) * item.count
          }, 0)
          const discount = localStorage.getItem('discount')
          let promo = false
          if (discount) {
            this.discount = parseInt(discount)
            promo = true
          }
          let real_amount = totalAmount - this.discount
          if (!data || promo) return this.amount = formatMoney(real_amount);
          this.real_amount = formatMoney(real_amount, 0)
          this.description = data.description
          if (data) {
            if (data.is_fix === 0) {
              real_amount = real_amount * (100 - data.sale) / 100
            } else {
              real_amount = real_amount - data.sale
            }
          }

          this.amount = formatMoney(real_amount, 0)
        }
      },

      onBack () {
        if (this.index > 0) {
          this.index--
        }
      },
      onNext () {
        this.index++
      },

      orderItem () {
        this.loader = this.$loading.show()
        this.isSubmitting = true
        let promo_code = localStorage.getItem('promo_code')
        const data = {
          payment_method: this.paymentMethod,
          promo_code: promo_code,
          promo_discount: 0,
          total_amount: this.amount,
          product: [],
          receiver_address: this.address,
          receiver_phone: this.phone,
          receiver_name: this.name
        }

        if (this.carts && this.carts.length > 0) {
          this.carts.forEach(cart => {
            if (cart.id) {
              data.product.push({
                product_id: cart.id,
                count: cart.count
              })
            }
          })
        } else {
          errorToaster('Cố vấn Phong Thủy', 'Chưa có đơn hàng nào trong giỏ hàng')
          return
        }
        if (validatorPhone(data.receiver_phone)) {
          this.$Progress.start()
          rf.getRequest('OrderRequest').orderItem(data).then((res) => {
            if (res.status === 200) {
              localStorage.setItem('carts', '')
              const req = {
                order_id: res.data.order_id,
                order_code: res.data.order_code,
                customer_number: res.data.receiver_phone,
                description: `Thanh toan don hang ${res.data.order_code}`,
                payment_method: res.data.payment_method,
                amount: res.data.total_amount,
                url_payment: getUrlPayment(),
                payment_type: OrderType.ORDER_VP
              }

              this.$Progress.finish()

              if (this.paymentMethod === PaymentMethod.PAYMENT_VTC_PAY) {
                this.vtcPay(req)
              } else {
                infoToaster('Cố vấn Phong Thủy', 'Đơn hàng của Quý khách đang được xử lý.')
                this.loader.hide()
                this.$router.push('/')
              }
            } else {
              errorToaster('Cố vấn Phong Thủy', 'Đơn hàng không hợp lệ')
              this.isSubmitting = false
              this.loader.hide()
            }
          }).catch(err => {
            errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
            this.$Progress.fail()
            this.loader.hide()
            this.isSubmitting = false
          })
        }
      },

      vtcPay (req) {
        rf.getRequest('OrderRequest').vtcPay(req).then((res) => {
          this.loader.hide()
          this.isSubmitting = false
          if (res.status === 200) {
            localStorage.setItem('carts', '')
            window.location.href = res.data
          }
        }).catch(err => {
          this.loader.hide()
          this.isSubmitting = false
          errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  .back-icon {
    position: absolute;
    top: 24px;
    font-size: 18px;
    color: gray;
    cursor: pointer;
    z-index: 10;
  }

  .content {
    .radio {
      display: block;
      position: relative;
      padding-left: 30px;
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 20px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none
    }

    .radio input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .checkround {

      position: absolute;
      top: 6px;
      left: 0;
      height: 20px;
      width: 20px;
      background-color: #fff;
      border-color: #34c300;
      border-style: solid;
      border-width: 2px;
      border-radius: 50%;
    }

    .radio input:checked ~ .checkround {
      background-color: #fff;
    }

    .checkround:after {
      content: "";
      position: absolute;
      display: none;
    }

    .radio input:checked ~ .checkround:after {
      display: block;
    }

    .radio .checkround:after {
      left: 2px;
      top: 2px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #34c300;
    }
  }

  .content-confirm {
    width: 100%;

    .confirm {
      padding: 16px;
      background: #fff none repeat scroll 0% 0%;
      margin: 8px 0px;
      width: 100%;

      .title {
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 5px;
      }

      .detail {
        color: gray;
        margin-bottom: 4px;
        font-size: 14px;
      }

      .detail-vat {
        color: gray;
        margin-bottom: 4px;
        font-size: 14px;
        display: inline-block;
        width: 100%;
      }

      .amount-detail {
        width: 100%;

        .title {
          float: left;
          font-weight: bold;
          font-size: 18px;
          padding-bottom: 5px;
        }

        .amount {
          color: red;
          font-weight: bold;
          float: right;
          font-size: 18px;
          padding-bottom: 5px;
        }
      }

      .flash_sale {
        color: red;
        font-size: 10px;
        font-weight: bold;
        font-style: italic;
        text-align: center;
        display: inline-block;
        width: 100%;
      }
    }
  }


  #msform {
    width: 100%;
    margin: 10px auto 0 auto;
    text-align: center;
    position: relative;
  }

  /*buttons*/
  #msform .action-button {
    width: 100px;
    background: #27AE60;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 1px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
  }

  #msform .action-button:hover, #msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #27AE60;
  }

  /*progressbar*/
  #progressbar {
    margin: 20px 0 10px 0;
    overflow: hidden;
    /*CSS counters to number the steps*/
    counter-reset: step;
  }

  #progressbar li {
    list-style-type: none;
    text-transform: uppercase;
    font-size: 10px;
    width: 50%;
    float: left;
    position: relative;
  }

  #progressbar li:before {
    content: counter(step);
    counter-increment: step;
    width: 30px;
    height: 30px;
    line-height: 30px;
    display: block;
    font-size: 10px;
    color: #EFEFEF;
    /*border-top: 2px solid #fff;*/
    background: #EFEFEF;
    border-radius: 50%;
    margin: 0 auto 5px auto;
  }

  /*progressbar connectors*/
  #progressbar li:after {
    content: '';
    width: 100%;
    height: 2px;
    background: #DDDDDD;
    position: absolute;
    left: -50%;
    top: 15px;
    z-index: -1;
  }

  #progressbar li:first-child:after {

    content: none;
  }

  #progressbar li.active:before, #progressbar li.active:after {
    background: #418AEB;
    color: #418AEB;
  }

  input[type='radio']:checked {
    color: #418AEB;
  }


</style>



// WEBPACK FOOTER //
// src/components/payment/Payment.vue